/* eslint-disable react/jsx-max-depth */
import { ActionIcon, Card, Flex, Grid, Menu, Text } from '@mantine/core';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import React from 'react';
import IconDots from '../../components/icons/IconDots';
import dompurify from 'dompurify';

export default function GridCol({
  item = {},
  onClickDelete = () => { },
  onClickDetail = () => { },
  onClickUpdate = () => { },
  span = 3,
}) {
  return (
    <Grid.Col span={span}>
      <Card radius="md" shadow="sm" style={{ height: 350 }} withBorder>
        <Card.Section inheritPadding py="xs" withBorder>
          <Flex justify="space-between">
            <Text weight={500}>{item.question}</Text>
            <Menu position="bottom-end" shadow="sm" withinPortal>
              <Menu.Target>
                <ActionIcon radius="xl" variant="subtle" >
                  <IconDots size={16} />
                </ActionIcon>
              </Menu.Target>

              <Menu.Dropdown>
                <Menu.Item onClick={onClickDetail}>Selengkapnya</Menu.Item>
                <Menu.Item onClick={onClickUpdate}>Ubah</Menu.Item>
                <Menu.Item color="red" onClick={onClickDelete}>
                  Hapus
                </Menu.Item>
              </Menu.Dropdown>
            </Menu>
          </Flex>
        </Card.Section>
        {/* <ScrollArea style={{ height: 250 }} type='never'> */}
        <Text color="dimmed" mt="sm" size="sm">
          <Text color="black" component="span" inherit>
            {parse(dompurify.sanitize(item.answer))}
          </Text>
        </Text>
        {/* </ScrollArea> */}
      </Card>
    </Grid.Col>
  );
}

GridCol.propTypes = {
  item: PropTypes.object,
  onClickDelete: PropTypes.func,
  onClickDetail: PropTypes.func,
  onClickUpdate: PropTypes.func,
  span: PropTypes.number,
};
